/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { EditPrintersDTO } from "../model";
import { EditPrintersDTOTrackedI, EditPrintersDTOMeta } from "../model";
// @ts-ignore
import type { PrinterDTO } from "../model";
import { PrinterDTOTrackedI, PrinterDTOMeta } from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * PrinterApi - axios parameter creator
 * @export
 */
export const PrinterApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Sends payment intent to card reader
     * @param {string} mac
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintTestMacPost: (
      mac: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'mac' is not null or undefined
      assertParamExists("staffPrintTestMacPost", "mac", mac);
      const localVarPath = `/staff/printTest/{mac}`.replace(
        `{${"mac"}}`,
        encodeURIComponent(String(mac)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns printers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintersGet: (options: RawAxiosRequestConfig = {}): RequestArgs => {
      const localVarPath = `/staff/printers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates printers
     * @param {EditPrintersDTO} editPrintersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintersPost: (
      editPrintersDTO: EditPrintersDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'editPrintersDTO' is not null or undefined
      assertParamExists(
        "staffPrintersPost",
        "editPrintersDTO",
        editPrintersDTO,
      );
      const localVarPath = `/staff/printers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editPrintersDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type staffPrintTestMacPostParams = { mac: string };
export type staffPrintersGetParams = {};
export type staffPrintersPostParams = {
  editPrintersDTO: EditPrintersDTOTrackedI;
};

export const staffPrintTestMacPostMeta = {
  mac: propertyMeta("mac", false, true, false, MetaTypesBase.string),
};
export const staffPrintersGetMeta = {};
export const staffPrintersPostMeta = {
  editPrintersDTO: propertyMeta(
    "editPrintersDTO",
    false,
    true,
    false,
    EditPrintersDTOMeta,
  ),
};

/**
 * PrinterApi - functional programming interface
 * @export
 */
export const usePrinterApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PrinterApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Sends payment intent to card reader
     * @param {string} mac
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintTestMacPostRaw(
      props: staffPrintTestMacPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPrintTestMacPost(
        props.mac,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrinterApi.staffPrintTestMacPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Returns printers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintersGetRaw(
      props: staffPrintersGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PrinterDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPrintersGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrinterApi.staffPrintersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<PrinterDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PrinterDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates printers
     * @param {EditPrintersDTO} editPrintersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintersPostRaw(
      props: staffPrintersPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PrinterDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPrintersPost(
        props.editPrintersDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrinterApi.staffPrintersPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<PrinterDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PrinterDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Sends payment intent to card reader
     * @param {string} mac
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintTestMacPost(
      mac: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPrintTestMacPost(
        mac,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrinterApi.staffPrintTestMacPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Returns printers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintersGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PrinterDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPrintersGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrinterApi.staffPrintersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<PrinterDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PrinterDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates printers
     * @param {EditPrintersDTO} editPrintersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPrintersPost(
      editPrintersDTO: EditPrintersDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PrinterDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPrintersPost(
        editPrintersDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrinterApi.staffPrintersPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<PrinterDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PrinterDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * PrinterApi - interface
 * @export
 * @interface PrinterApi
 */
export interface PrinterApiInterface {
  /**
   * Sends payment intent to card reader
   * @param {string} mac
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrinterApiInterface
   */
  staffPrintTestMacPost(
    mac: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Returns printers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrinterApiInterface
   */
  staffPrintersGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<PrinterDTO>>;

  /**
   * Updates printers
   * @param {EditPrintersDTO} editPrintersDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrinterApiInterface
   */
  staffPrintersPost(
    editPrintersDTO: EditPrintersDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<PrinterDTO>>;
}
